import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import Header from './header'
import Footer from './footer'
import AOS from 'aos'
import '../css/custom.scss'

import { IntlProvider, addLocaleData } from 'react-intl'

// Locale data
import enData from 'react-intl/locale-data/en'
import itData from 'react-intl/locale-data/it'

import en1 from '../i18n/en/messages.json'
import en2 from '../i18n/en/form.json'
import en3 from '../i18n/en/errors.json'
import it1 from '../i18n/messages.json'
import it2 from '../i18n/form.json'
import it3 from '../i18n/errors.json'
const messages = { en: {...en1, ...en2, ...en3}, it: {...it1, ...it2, ...it3} }
addLocaleData([...enData, ...itData])

class Layout extends React.Component {

  componentDidMount() {
    AOS.init({
      easing: 'ease-in-out-sine',
      duration: 600
    });
  }

  render() {
    const { children, locale } = this.props;
    return (
      <StaticQuery
        query={graphql`
          query LayoutQuery {
            site {
              siteMetadata {
                title
              }
            }
            navigationJson {
              it {
                header{
                  name
                  link
                }
                footer{
                  name
                  link
                }
              }
              en {
                header{
                  name
                  link
                }
                footer{
                  name
                  link
                }
              }
            }
          }
        `}
        render={data => (
          <IntlProvider locale={locale} messages={messages[locale]} defaultLocale="it">
            <div className="wrapper">
              <Header siteTitle={data.site.siteMetadata.title} navigation={data.navigationJson[locale]} locale={locale}/>
              <div id="main" className="main-wrapper" role="main">
                {children}
              </div>
              <Footer navigation={data.navigationJson[locale]} />
            </div>
          </IntlProvider>
        )}
      />
    );
  }

}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout;